export default {
  title: 'Paga con PayPal',
  error: 'Il pagamento PayPal non è andato a buon fine. Riprova.',
};
